/* Stack the BTOGO + separator-line sections directly below the sticky
   header by computing each one's `top` value live (Dawn already keeps
   --header-height in sync; we just add cumulative offsets). */
(function () {
  if (window.__stickyStackInit) return;
  window.__stickyStackInit = true;

  // NOTE: the announcement bar is intentionally NOT in this list — it's static
  // (scrolls away), so it must not be positioned or counted in the cumulative
  // offset (otherwise the BTOGO bar would stick with a gap below the header).
  const SELECTOR = [
    '.shopify-section.section-separator-line',
    '.shopify-section.section-btogo-banner',
    '.shopify-section[id*="separator-line"]',
    '.shopify-section[id*="btogo-banner"]',
  ].join(',');

  function getStickySections() {
    // Deduplicate and sort in document order.
    const set = new Set(document.querySelectorAll(SELECTOR));
    return Array.from(set).sort((a, b) => {
      const pos = a.compareDocumentPosition(b);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });
  }

  function update() {
    const headerVar =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;

    let cumulative = headerVar;
    getStickySections().forEach((el) => {
      el.style.top = cumulative + 'px';
      // Use offsetHeight so collapsed (max-height: 0) sections add 0.
      cumulative += el.offsetHeight;
    });

    // Reveal the stacked bars only once their offsets are computed against a
    // real header height — prevents the load-time flash-then-jump on mobile
    // (CSS keeps them visibility:hidden until this class is set).
    if (headerVar > 0) {
      document.documentElement.classList.add('sticky-stack-ready');
    }
  }

  let raf = null;
  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      update();
    });
  }

  // Initial + on resize + after every animation frame for ~1s after load
  // (covers fonts settling, header height changes, BTOGO expand/collapse).
  schedule();
  // Fail-safe: never leave the bars hidden if the header height never resolves.
  setTimeout(function () {
    document.documentElement.classList.add('sticky-stack-ready');
  }, 1000);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  // Watch the sticky sections themselves for size changes (BTOGO expanding,
  // separator padding edits in editor, etc.).
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(schedule);
    function observeAll() {
      getStickySections().forEach((el) => ro.observe(el));
      // Also observe the header so --header-height changes are picked up
      // even before Dawn dispatches its own update.
      const header = document.querySelector('.section-header, .shopify-section-header-sticky');
      if (header) ro.observe(header);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
  }

  // MutationObserver to catch BTOGO data-state changes (visibility flip).
  const banner = document.querySelector('[data-btogo-banner]');
  if (banner) {
    new MutationObserver(schedule).observe(banner, {
      attributes: true,
      attributeFilter: ['data-btogo-state'],
    });
  }
})();
